import { isNone } from '@ember/utils';
import { underscore as stringUnderscore } from '@ember/string';
import { camelize, underscore } from '@square/dashboard-utilities/utils/keys';
export function clone(store, sourceModel, ignoredAttributes = new Set()) {
  const modelName = sourceModel.constructor.modelName;
  const sourceModelJSON = sourceModel.serialize();
  ignoredAttributes.forEach(attribute => {
    delete sourceModelJSON[stringUnderscore(attribute)];
  });
  return sourceModel._isFragment ? store.createFragment(modelName, transformJSON(store, modelName, sourceModelJSON)) : store.createRecord(modelName, transformJSON(store, modelName, sourceModelJSON));
}
export function transformJSON(store, modelName, properties) {
  const transformedProps = normalizeSKU(camelize(properties));
  const modelClass = store.modelFor(modelName);
  modelClass.eachTransformedAttribute((attribute, type) => {
    const attributeValue = transformedProps[attribute];
    if (!isNone(attributeValue)) {
      transformedProps[attribute] = transformAttribute(store, modelName, type, attribute, transformedProps[attribute]);
    }
  });
  return transformedProps;
}
function transformAttribute(store, modelName, type, attribute, attributeValue) {
  const serializer = store.serializerFor(modelName);
  const modelClass = store.modelFor(modelName);
  const transform = serializer.transformFor(type);
  let options = {};
  if (type.includes('-mf-fragment')) {
    let fragmentName;
    if (type.includes('-mf-fragment-array$')) {
      // this is a fragment array, we loop through each fragment and recursively trickle the transform down
      fragmentName = type.replace('-mf-fragment-array$', '');
      const transformedFragmentArray = [];
      // Naming is a little misleading, since attributeValue here is an array
      for (const [i, element] of attributeValue.entries()) {
        transformedFragmentArray[i] = transformJSON(store, fragmentName, element);
      }
      return transformedFragmentArray;
    } else {
      // this is a fragment, we recursively trickle the transform down
      fragmentName = type.replace('-mf-fragment$', '');
      return transformJSON(store, fragmentName, attributeValue);
    }
  } else if (type === 'proto-base-model' || type === 'ember-model-belongs-to') {
    options = modelClass.attributes.get(attribute).options;
    return transform.deserialize(underscore(attributeValue), options);
  } else if (type === 'enum') {
    options = modelClass.attributes.get(attribute).options;
    return transform.deserialize(attributeValue, options);
  }
  return transform.deserialize(attributeValue);
}

// HACK(qvu): Ember String's underscore works such that
// undesrcore('vendorSKU') would translate to vendor_sku, hence the other
// cases work without needing to change this key on the JSON. However, in
// our own camelize function which vendor_sku into vendorSku and not vendorSKU
function normalizeSKU(JSON) {
  if (!isNone(JSON) && typeof JSON === 'object') {
    Object.keys(JSON).forEach(key => {
      if (key.includes('Sku')) {
        const newKey = key.replace('Sku', 'SKU');
        JSON[newKey] = JSON[key]; // eslint-disable-line no-param-reassign
        delete JSON[key]; // eslint-disable-line no-param-reassign
        normalizeSKU(JSON[newKey]);
      }
    });
  }
  return JSON;
}